import { render } from "./SignIn.vue?vue&type=template&id=474620ca&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=474620ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-474620ca"

export default script